"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MinceAbilityHandler = exports.MinceActorAbilityFactory = exports.MinceAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Random_1 = require("../../utils/Random");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
class MinceAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Mince;
        this.__typeName = "Mince";
    }
}
exports.MinceAbilityArgs = MinceAbilityArgs;
let MinceActorAbilityFactory = class MinceActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Mince", "OneEnemies", 4);
    }
};
MinceActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Mince")
], MinceActorAbilityFactory);
exports.MinceActorAbilityFactory = MinceActorAbilityFactory;
let MinceAbilityHandler = class MinceAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedEnemy] = ability.args.target.actorIds;
        const timesToStrike = (0, Random_1.random)(3, 6);
        for (let i = 0; i < timesToStrike; i++) {
            if (container.isDeceased(selectedEnemy) || container.isDeceased(ability.invokerId)) {
                return;
            }
            // 1. move to Target
            // 2. apply additional attacks/damages
            // 3. return to home
            container.applyAttack({
                sequence,
                abilityKey: i === 0 ? ability.args.__typeName
                    : undefined,
                type: i === 0 ? "melee"
                    : "melee_tick",
                attackerId: ability.invokerId,
                targetId: selectedEnemy,
                onHit: (hitSequence, _, attack) => {
                    sequence = hitSequence;
                    container.applyAttackDamage({
                        attackType: i === 0 ? "melee"
                            : "melee_tick",
                        sequence,
                        attackerId: ability.invokerId,
                        targetId: selectedEnemy,
                        isCrit: attack.crit,
                        toApply: AbilityDamage_1.AbilityDamage.Power("Physical", 50)
                    });
                    if (container.hasAttribute(ability.invokerId, "Charm_Assassin_0")) {
                        container.applyDebuff({
                            sequence,
                            attackerId: ability.invokerId,
                            targetId: selectedEnemy,
                            duration: Duration_1.Duration.Turns(4),
                            effect: new core_1.VulnerabilityEffectArgs(1)
                        });
                    }
                }
            });
        }
    }
};
MinceAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Mince)
], MinceAbilityHandler);
exports.MinceAbilityHandler = MinceAbilityHandler;
